import { useEffect, useRef, useCallback } from "react";
import classes from "./Modal.module.css";

function Modal(props) {
  const contentRef = useRef(null);
  const previousFocusRef = useRef(null);

  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === "Escape") {
        if (typeof props.onClose === "function") props.onClose();
        return;
      }
      // Trap focus inside the modal
      if (e.key === "Tab" && contentRef.current) {
        const focusable = contentRef.current.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        if (focusable.length === 0) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey) {
          if (document.activeElement === first) {
            e.preventDefault();
            last.focus();
          }
        } else {
          if (document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      }
    },
    [props]
  );

  useEffect(() => {
    previousFocusRef.current = document.activeElement;
    // Focus the first focusable element inside the modal
    if (contentRef.current) {
      const focusable = contentRef.current.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (focusable.length > 0) focusable[0].focus();
    }
    return () => {
      // Restore focus when modal closes
      if (previousFocusRef.current && typeof previousFocusRef.current.focus === "function") {
        previousFocusRef.current.focus();
      }
    };
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [handleKeyDown]);

  return (
    <div
      className={classes.modal}
      role="dialog"
      aria-modal="true"
      aria-label={props["aria-label"] || "Dialog"}
    >
      <div className={classes.content} ref={contentRef}>
        {props.children}
      </div>
    </div>
  );
}

export default Modal;
